import { createContext, useContext, useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const HomePageContext = /*#__PURE__*/createContext({
  hidden: false,
  setHidden() {}
});
export const useHomePage = () => useContext(HomePageContext);
export default function HomePageProvider(props) {
  const [hidden, setHidden] = useState(props.initiallyHidden || false);
  const value = useMemo(() => ({
    hidden,
    setHidden
  }), [hidden]);
  return /*#__PURE__*/_jsx(HomePageContext.Provider, {
    value: value,
    children: props.children
  });
}